import React from 'react';
import Routes from './utils/routes/routes';

const App = () => {
  return (
    <div>
      <Routes />
    </div>
  );
};

export default App;
